import { WorkflowUpdateRecordDialogComponent } from './action-components/workflow-update-record-dialog/workflow-update-record-dialog.component';
import { SalesOrderService } from './../../inventory/sales-order/sales-order.service';
import { WorkflowTaskAddDialogComponent } from './action-components/workflow-task-add-dialog/workflow-task-add-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkflowRoutingModule } from './workflow-routing.module';
import { SavedSearchesService } from '../saved-searches/services/saved-searches.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContextMenuModule } from 'primeng/contextmenu';
import { SharedComponentModule } from './../../modules/shared/shared.module';
import { PrimngDesignModule } from './../../modules/primng-design/primng-design.module';
import { ReportsSharedModule } from './../../reports/reports-shared.module';
import { WorkflowComponent } from './workflow.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ListboxModule } from 'primeng/listbox';
import { StepsModule } from 'primeng/steps';
import { WorkflowDetailsComponent } from './workflow-details/workflow-details.component';
import { WorkflowService } from './services/workflow.service';
import { AddEditWorkflowDialogComponent } from './add-edit-workflow-dialog/add-edit-workflow-dialog.component';
import { WorkflowAddSavedSearchRulesComponent } from './action-components/workflow-add-saved-search-rules/workflow-add-saved-search-rules.component';
import { WorkflowTriggerTimeDialogComponent } from './action-components/workflow-trigger-time-dialog/workflow-trigger-time-dialog.component';
import { WorkflowUpdateFieldDialogComponent } from './action-components/workflow-update-field-dialog/workflow-update-field-dialog.component';
import { WorkflowEmailAddDialogComponent } from './action-components/workflow-email-add-dialog/workflow-email-add-dialog.component';
import { WorkflowCreateRecordDialogComponent } from './action-components/workflow-create-record-dialog/workflow-create-record-dialog.component';
import { WorkflowApprovalsAddDialogComponent } from './action-components/workflow-approvals-add-dialog/workflow-approvals-add-dialog.component';
import { ProductsService } from '../../inventory/products/products.service';

@NgModule({
    declarations: [
        WorkflowComponent,
        WorkflowDetailsComponent,
        AddEditWorkflowDialogComponent,
        WorkflowTaskAddDialogComponent,
        WorkflowEmailAddDialogComponent,
        WorkflowAddSavedSearchRulesComponent,
        WorkflowTriggerTimeDialogComponent,
        WorkflowUpdateFieldDialogComponent,
        WorkflowCreateRecordDialogComponent,
        WorkflowUpdateRecordDialogComponent,
        WorkflowApprovalsAddDialogComponent
    ],
    imports: [
        CommonModule,
        WorkflowRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        ContextMenuModule,
        SharedComponentModule,
        PrimngDesignModule,
        ReportsSharedModule,
        ListboxModule,
        StepsModule
    ],
    providers: [
        WorkflowService,
        SavedSearchesService,
        ConfirmationService,
        MessageService,
        SalesOrderService,
        ProductsService
    ],
    exports: []
})
export class WorkflowModule { }
